import React, {useEffect, useState} from 'react';
import { TextField, InputAdornment, IconButton, Grid } from "@mui/material";
import { Visibility, VisibilityOff } from '@mui/icons-material';
function PasswordField({setPasswordErrorParent,setPasswordParent}) {
  const [values, setValues] = useState({
    password: '',
    confirmPassword: '',
    showPassword: false,
    showConfirmPassword: false,
  });

  const handleChange = (prop) => (event) => {
    setValues({ ...values, [prop]: event.target.value });
  };

  const handleClickShowPassword = () => {
    setValues({ ...values, showPassword: !values.showPassword });
  };

  const handleClickShowConfirmPassword = () => {
    setValues({ ...values, showConfirmPassword: !values.showConfirmPassword });
  };
  const [passwordError, setPasswordError] = useState(null);

useEffect(() => {
  if (values.password && values.confirmPassword) {
    if (values.password !== values.confirmPassword) {
      setPasswordError("Şifreler uyuşmuyor!");
      setPasswordErrorParent(true);
    } else {
      setPasswordError(false);
      setPasswordErrorParent(false);
      setPasswordParent(values.password)
    }
  }
}, [values.password, values.confirmPassword]);


  return (
    <>
        <Grid item xs={12} sm={6}>
            <label>Şifre</label>
            <span style={{fontSize:12, color:'red'}}> (Şifre en az 8 karakter uzunluğunda olmalı ve en az bir büyük harf ile en az bir özel karakter içermelidir.)</span>
            <TextField
                size="small"
                name="password"
                placeholder="Şifre"
                type={values.showPassword ? 'text' : 'password'}
                fullWidth
                variant="outlined"
                value={values.password}
                onChange={handleChange('password')}
                InputProps={{
                    endAdornment: (
                        <InputAdornment position="end">
                            <IconButton onClick={handleClickShowPassword}>
                                {values.showPassword ? <Visibility/> : <VisibilityOff/>}
                            </IconButton>
                        </InputAdornment>
                    ),
                }}
            />
        </Grid>
        <Grid item xs={12} sm={6}>
            <label>Şifreyi Tekrar Girin {passwordError && <div style={{color:'red'}}>{passwordError}</div>}</label>

            <TextField
                size="small"
                name="confirmPassword"
                placeholder="Şifreyi Yinele"
                type={values.showConfirmPassword ? 'text' : 'password'}
                fullWidth
                variant="outlined"
                value={values.confirmPassword}
                onChange={handleChange('confirmPassword')}
                InputProps={{
                    endAdornment: (
                        <InputAdornment position="end">
                            <IconButton onClick={handleClickShowConfirmPassword}>
                                {values.showConfirmPassword ? <Visibility/> : <VisibilityOff/>}
                            </IconButton>
                        </InputAdornment>
                    ),
                }}
            />
        </Grid>

    </>
  );
}

export default PasswordField;
